<template>
  <div>
    <div v-for="cap in capabilities" v-if="cap in $root.capabilities" class="cap">
      <div v-if="$root.capabilities[cap].set">

        <!-- Sätt / boolean (toggle) -->
        <div v-if="$root.capabilities[cap].type === 'boolean'">
          <div v-if="cap in events && 'value' in events[cap]">
            <button @click="set(cap, { value: true })" :style="style(events[cap].value, true)">På</button>
            <button @click="set(cap, { value: false })" :style="style(!events[cap].value, false)">Av</button>
          </div>
          <div v-else>
            <button @click="set(cap, { value: true })" :style="{ 'width': '46%' }">På</button>
            <button @click="set(cap, { value: false })" :style="{ 'width': '46%' }">Av</button>
          </div>
        </div>

        <!-- Sätt / number (range) -->
        <div v-if="$root.capabilities[cap].type === 'number'">
          <div style="float:left;width:80%">
            <input v-if="cap in events && 'value' in events[cap]" min="0" max="100" step="10" type="range" v-model="events[cap].value*100" @change="setValue(cap, $event)">
            <input v-else type="range" min="0" max="100" step="10" @change="setValue(cap, $event)">
          </div>
          <div v-if="cap in events && 'value' in events[cap]" style="float:right;font-size:13px;padding-top:3px;">{{ parseInt(events[cap].value*100) }}%</div>
          <div class="clear"></div>
        </div>

        <!-- Enum -->
        <div v-if="$root.capabilities[cap].type === 'enum'">
          
          <div v-if="cap in events && 'value' in events[cap]">
            <button @click="set(cap, { value: true })" :style="style(events[cap].value, true)">På</button>
          </div>
          <div v-else>
            <button @click="set(cap, { value: true })" :style="{ 'width': '46%' }">På</button>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="cap in events">
          <div v-if="$root.capabilities[cap].type === 'number'">
            <div class="capability">{{ $root.capabilities[cap].name }}</div>
            <div class="value">{{ events[cap].value }}{{ $root.capabilities[cap].unit }}</div>
          </div>
          <div v-else>
            <div class="capability">{{ $root.capabilities[cap].name }}</div>
            <div class="value">{{ $root.capabilities[cap].values[events[cap].value].name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SpringSpinner } from 'epic-spinners'
  import { eventbus } from '../../eventbus.js'
  import { HTTP } from '../../http.js'

  export default {
    name: 'capability',
    props: ['nodeId', 'events', 'capabilities'],
    components: {
      SpringSpinner
    },
    data () {
      return {}
    },
    created () {},
    methods: {
      style (active, bool) {
        let inactiveColor = '#e7e7e7'
        
        let obj =  {
          'width': '46%', 
          'font-weight': (active ? 'bold' : '100'),
          'border': '1px solid ' + (active ? '#AACE64' : inactiveColor),
          'border-bottom': '3px solid ' + (active ? '#AACE64' : inactiveColor),
        }
        
        if (active && !bool) {
          obj['border'] = '1px solid ' + (active ? '#F16B56' : inactiveColor)
          obj['border-bottom'] = '3px solid ' + (active ? '#F16B56' : inactiveColor)
        }
        
        if (active) {
          obj['color'] = '#000'
        }
        
        return obj
      },
      
      set (capability, event) {
        const value = event.value
        const cap = this.$root.capabilities[capability]

        if (!(capability in this.events)) {
          this.events[capability] = {
            value: value,
            time: new Date()
          }
        }

        let setObject = {
          value: cap.values[value].method === 'turnOn',
          cap: capability
        }

        if (!this.$root.isNX2) {
          setObject = {
            method: cap.values[value].method,
            cap: capability
          }
        }
        
        // Skickar anropet till Bridgen så att lampan faktiskt
        // tänds eller släcks som den skall.
        HTTP.post('nodes/' + this.nodeId + '/call', setObject)
        .then(res => res.data)
        .then(json => {
                    
        })

        this.events[capability].value = value
      },
      
      setValue (capability, event) {
        const value = parseInt(event.target.value)
        const cap = this.$root.capabilities[capability]
                
        if (!(capability in this.events)) {
          this.events[capability] = {
            value: value,
            time: new Date()
          }
        }

        let setObject = {
          value: value / 100,
          cap: capability
        }

        if (!this.$root.isNX2) {
          setObject = {
            method: 'setValue',
            cap: capability,
            arguments: [value/100]
          }
        }


        // Skickar anropet till Bridgen så att lampan faktiskt
        // tänds eller släcks som den skall.
        HTTP.post('nodes/' + this.nodeId + '/call', setObject)
        .then(res => res.data)
        .then(json => {

        })
      }
    },
    computed: {
      capability (name) {
        return this.$root.capabilities[name]
      }
    },
    destroyed () {}
  }
</script>

<style>
  .cap {
    padding-bottom:8px;
  }


  .capability {
    font-size:12px;
    color:#949494;
    margin-bottom:2px;
  }
  
  .value {
    font-size:14px;
  }
  
  button {
    border-radius:2px;
    font-size:13px;
  }
  
  button.active {
    font-weight: bold;
    text-decoration: underline;
  }

  input[type=range] {
    -webkit-appearance: none;
    background-color: #d2d2d2;
    width: 100%;
    height:20px;
    box-sizing: border-box;
    outline: none;
  }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    background-color: #03335A;
    opacity: 0.7;
    width: 10px;
    height: 26px;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/capability.vue